import React from 'react';
import { ModuleBridge } from '../components';

export const ViewDmProfile = () => {
    return <ModuleBridge moduleId="create_dm_profile_module" />;
};
